module.exports = __webpack_public_path__ + "static/media/logo.185627ef.png";